<template>
    <div></div>
</template>

<script>
    export default {
        name: "EmptyComponent"
    }
</script>

<style scoped>

</style>